<template>
	<div class="ProgrammeExternalServices">
		<div
			v-if="isMasters"
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '7.433rem', height: '1.25rem' },
					Large: { width: '80%', height: '1.25rem' },
					ExtraLarge: { width: '7.433rem', height: '1.25rem' },
				},
				margins: {
					Small: '0.5rem 0',
				},
			}"
			class="BestFitOverview"
			:data-study-id="programmeId"
			data-widget-type="omni_search_button_icon"
			data-widget-location="sblp_search_study_card"
			data-empty-text="Check Your Fit"
		></div>

		<div
			v-skeleton="{
				loading,
				sizes: {
					Small: { width: '1.25rem', height: '1.25rem' },
				}
			}"
			class="WishlistButton"
			:data-study-id="programmeId"
			data-button-type="omni_search_icon_only"
		></div>
	</div>

</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
	programmeId: {
		type: String,
		required: true,
	},
	isMasters: {
		type: Boolean,
		required: true,
	},
	loading: {
		type: Boolean,
		default: false,
	},
});

const justifyContent = computed(()=> props.isMasters ? 'space-between' : 'flex-end');
</script>

<style scoped lang="scss">
.ProgrammeExternalServices {
	position: relative;
	display: flex;
	justify-content: v-bind(justifyContent);
	align-items: center;
	width: 100%;

	@include Breakpoint(Large, ExtraLarge) {
		gap: 0.5rem;
		justify-content: flex-end;
		top: -0.5rem;
		max-width: 10rem;
	}
}
</style>
